const BASE = '/api';

function authHeaders(sessionToken: string | null): HeadersInit {
  const h: Record<string, string> = { 'Content-Type': 'application/json' };
  if (sessionToken) h['X-Session-Token'] = sessionToken;
  return h;
}

export async function apiGet<T = any>(path: string, sessionToken: string | null): Promise<T> {
  const res = await fetch(`${BASE}${path}`, { headers: authHeaders(sessionToken), cache: 'no-store' });
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  if (!res.ok) throw new Error(data.error || `GET ${path} failed`);
  return data;
}

export async function apiPost<T = any>(path: string, body: any, sessionToken: string | null): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    method: 'POST',
    headers: authHeaders(sessionToken),
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  if (!res.ok) throw new Error(data.error || `POST ${path} failed`);
  return data;
}

export interface ChecklistSummary {
  id: number;
  slug: string;
  name: string;
  frequency: 'daily' | 'weekly' | 'monthly' | 'one_time';
  is_active: boolean;
  section_count: number;
  item_count: number;
}

export interface ChecklistItem {
  id: number;
  section_id: number;
  label: string;
  hint: string | null;
  sort_order: number;
}

export interface ChecklistSection {
  id: number;
  template_id: number;
  group_name: string | null;
  name: string;
  sort_order: number;
  items: ChecklistItem[];
}

export interface ChecklistFull {
  id: number;
  slug: string;
  name: string;
  frequency: string;
  is_active: boolean;
  sections: ChecklistSection[];
}

export interface SubmissionSummary {
  id: number;
  template_id: number;
  template_name: string;
  template_slug: string;
  submitted_by_user_id: number;
  submitted_by_name: string;
  submitted_at: string;
  notes: string | null;
  completed_count: number;
  total_count: number;
}

export interface SubmissionResponse {
  item_id: number;
  is_completed: boolean;
  notes: string | null;
  label: string;
  section_id: number;
  section_name: string;
  group_name: string | null;
  section_sort: number;
  item_sort: number;
}

export interface SubmissionDetail {
  submission: SubmissionSummary;
  responses: SubmissionResponse[];
}
